// core
import React from "react";
import ReactDOM from "react-dom";

// components
import App from "./App";

// providers
import RootContextProvider from "./providers/RootContextProvider";
import AppWrapper from "./components/AppWrapper/AppWrapper";

ReactDOM.render(
    // <React.StrictMode>

    <RootContextProvider>
        <AppWrapper>
            <App />
        </AppWrapper>
    </RootContextProvider>,
    document.getElementById("app")
);
